import { Capacitor } from '@capacitor/core';
import { encodeData } from '../utils/Helper';

console.log("env", process.env.REACT_APP_API_BASE_URL)

export const Config = {
    url: '',
    // REACT_APP_API_BASE_URL: 'https://demo.dev9server.com:3340/api/',  // STG
    // REACT_APP_API_BASE_URL: 'https://demo.dev9server.com:3360/api/',  // DEV
    // REACT_APP_API_BASE_URL: 'http://159.203.152.180:3020/api/',  // DEV  
    // REACT_APP_API_BASE_URL: 'https://staging-api.justivide.com/api/',  // LIVE STG
    // REACT_APP_API_BASE_URL: 'http://localhost:3030/api/',  // LOCAL
    // REACT_APP_API_BASE_URL: 'https://c91b-150-107-232-52.ngrok-free.app/api/',  // LOCAL
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,  // LOCAL

    // BASE_URL: window.location.hostname === 'localhost' ? '' : process.env.BASE_URL, //STG
    // BASE_URL: window.location.hostname === 'localhost' ? '' : process.env.BASE_URL,  //DEV
    BASE_URL: process.env.REACT_APP_BASE_URL,
    APP_NAME: process.env.APP_NAME,
    APP_DEVELOPED_BY: process.env.APP_DEVELOPED_BY,
    CRYPTO_ENCRYPTION_KEY: process.env.CRYPTO_ENCRYPTION_KEY,
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY
};